<template>
  <div>
    <div v-if="pageData">
      <Inquiry v-if="pageData.staticFlag && slug == 'inquiry'"/>
      <Address v-if="pageData.staticFlag && slug == 'address'"/>
      <CardDetail v-if="pageData.staticFlag && slug == 'card-detail'"/>
      <CardRegister v-if="pageData.staticFlag && slug == 'card-register'"/>

      <ArticleThumb
        v-else-if="pageData.layout == getLayoutType('ARTICLES_1_COL')"
        :pageData="pageData"
      />
      <ArticleCol
        v-else-if="pageData.layout == getLayoutType('ARTICLES_2_COL')"
        :pageData="pageData"
      />
      <CardList v-else-if="pageData.layout == getLayoutType('CARD_LIST')" :pageData="pageData"/>
      <BranchList v-else-if="pageData.layout == getLayoutType('BRANCH_LIST')" :pageData="pageData"/>
      <HtmlContent
        v-else-if="pageData.layout == getLayoutType('HTML_CONTENT')"
        :pageData="pageData"
      />
      <div v-if="this.totalPages > 1" class="pagination-container">
        <paginate
          :page-count="totalPages"
          :container-class="'pagination'"
          :prev-text="'<'"
          :next-text="'>'"
          :click-handler="onPageClick"
        >
          <span slot="breakViewContent">
            <svg width="16" height="4" viewBox="0 0 16 4">
              <circle fill="#999999" cx="2" cy="2" r="2"></circle>
              <circle fill="#999999" cx="8" cy="2" r="2"></circle>
              <circle fill="#999999" cx="14" cy="2" r="2"></circle>
            </svg>
          </span>
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleThumb from "@/components/layout/ArticleThumb.vue";
import ArticleCol from "@/components/layout/ArticleCol.vue";
import HtmlContent from "@/components/layout/HtmlContent.vue";
import CardList from "@/components/layout/CardList.vue";
import BranchList from "@/components/layout/BranchList.vue";

import Inquiry from "@/views/static/Inquiry.vue";
import Address from "@/views/static/Address.vue";
import CardDetail from "@/views/static/CardDetail.vue";
import CardRegister from "@/views/static/CardRegister.vue";

import MenuService from "@/services/MenuService.js";
import { LayoutType } from "@/constants/layoutType";

export default {
  components: {
    ArticleThumb,
    ArticleCol,
    HtmlContent,
    CardList,
    BranchList,
    Inquiry,
    Address,
    CardDetail,
    CardRegister
  },

  data() {
    return {
      pageData: null,
      pageNum: 1,
      totalPages: 0
    };
  },

  computed: {
    slug() {
      return this.$route.params.slug;
    },

    topmenus() {
      return this.$store.state.topmenus;
    }
  },

  watch: {
    topmenus() {
      this.getSubmenu();
    }
  },

  created() {
    this.$store.dispatch("setHasBreadcrumb", true);

    if (this.topmenus) {
      this.getSubmenu();
    }
  },

  methods: {
    getSubmenu(page) {
      MenuService.getSubmenu(this.slug, page)
        .then(response => {
          let res = response.data;
          if (res.success) {
            if (res.payload.layout == LayoutType.MENU) {
              let slug = res.payload.childEntries.rows[0].url.replace(
                "/m/",
                ""
              );
              this.$router.push({ name: "Submenu", params: { slug: slug } });
            } else {
              this.pageData = res.payload;
              this.totalPages = this.pageData.childEntries.totalPages;
              this.pageNum = this.pageData.childEntries.pageNum;
              this.getSidemenu(
                res.payload.parentId,
                res.payload.contents[0].title
              );

              this.$store.dispatch(
                "setPageTitle",
                res.payload.contents[0].title
              );
            }
          } else {
            this.$router.push({ name: "Homepage" });
          }
        })
        .catch(error => {
          this.$router.push({ name: "Homepage" });
        });
    },

    getLayoutType(type) {
      return LayoutType[type];
    },

    onPageClick(pageNum) {
      this.pageNum = pageNum;
      this.getSubmenu(pageNum);
      document.getElementById("scrollTop").click();
    }
  },

  beforeRouteUpdate(to, from, next) {
    // HTML Content created() sets this false, so update the value when leaving HTML Content
    this.$store.dispatch("setHasBreadcrumb", true);

    if ($(".slick-slider").length) {
      $(".slick-slider").addClass("is-invisible");
      if ($(".slick-slider").hasClass("is-invisible")) {
        next();
      }
    } else {
      next();
    }
  }
};
</script>

<style>
.pagination-container {
  text-align: center;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline-block;
  margin: 0 2px;
}
.pagination > li > a,
.pagination > li > span {
  padding: 4px 12px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;

  color: #333;
}
.pagination > li > a:hover {
  background-color: #ddd;
}
.pagination > li.active > a {
  background-color: #f89025 !important;
  color: #fff;
}
</style>